import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DotMenu, { Options } from '../primitives/dotMenu/DotMenu';
import { MenuConstants } from '../../constants/MenuConstants';
import ActionDropdown from '../primitives/dropdowns/ActionDropdown';
import { find } from 'lodash';
import Modal from '../shared/ModalPortal/Modal';

interface AssignCategoryToOrgProps {
  orgList: any;
  onOrgSelected: Function;
  enableAssignToOrg: Boolean;
  selectedCategories: any;
  searchData?: any;
  searchable?: boolean;
  fetchMoreData?: Function;
  hasMore?: boolean;
  filtersList?: any;
  setShowAssignOrg?: any;
  showAssignOrg?: any;
}

const AssignCategoryToOrg: React.FC<AssignCategoryToOrgProps> = ({
  orgList,
  onOrgSelected,
  enableAssignToOrg,
  selectedCategories,
  searchData,
  searchable,
  fetchMoreData,
  hasMore = false,
  filtersList,
  setShowAssignOrg,
  showAssignOrg
}) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<Options | null>();
  const [dropDownOptions, setDropDownOptions] = useState<any>([]);
  const [orgFilterObj, setOrgFilterObj] = useState<any>({});
  const [hasMoreOrgData, setHasMoreOrgData] = useState<any>(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (filtersList && filtersList.length) {
      const orgFilterObj = find(filtersList, { id: 'orgFilter' });
      if (orgFilterObj) {
        const options = orgFilterObj.itemsList.map((org: any) => {
          return {
            display: org.name,
            key: org.id
          };
        });
        setOrgFilterObj(orgFilterObj);
        setDropDownOptions(options);
        setHasMoreOrgData(orgFilterObj.hasMore);
      }
    }
  }, [filtersList]);

  return (
    <>
      {/* <ActionDropdown
        options={dropDownOptions}
        className={!enableAssignToOrg ? 'disabled' : ''}
        onSelectedOptionChange={(value: any) => {
          onOrgSelected(value);
        }}
        searchData={searchData}
        searchable={searchable}
        fetchMoreData={fetchMoreData}
        hasMore={hasMoreOrgData}
        searchPlaceholder={t('T_SEARCH_ORG_NAME')}
        value={selectedOption}
        defaultLabel={
          enableAssignToOrg
            ? `${t('T_ASSIGN_SELECTED')} (${selectedCategories.length})`
            : t('T_SELECT_CATEGORY_TO_ASSIGN')
        }
      /> */}
      {showAssignOrg && (
        <Modal
          showHeader={true}
          showCloseIcon={true}
          width="22rem"
          headerText={t('T_SELECT_ORG_TO_ASSIGN')}
          toggleVisiblity={(value: boolean) => {
            setShowAssignOrg(false);
          }}
          isVisible={true}
          overflowVisible={true}
          className=""
          body={
            <ActionDropdown
              options={dropDownOptions}
              className={!enableAssignToOrg ? 'disabled' : ''}
              onSelectedOptionChange={(value: any) => {
                setShowAssignOrg(false);
                onOrgSelected(value);
              }}
              searchData={searchData}
              searchable={searchable}
              fetchMoreData={fetchMoreData}
              hasMore={hasMoreOrgData}
              searchPlaceholder={t('T_SEARCH_ORG_NAME')}
              value={selectedOption}
              defaultLabel={
                enableAssignToOrg
                  ? `${t('T_ASSIGN_SELECTED')} (${selectedCategories.length})`
                  : t('T_SELECT_CATEGORY_TO_ASSIGN')
              }
            />
          }
          // secondaryOnClick={setShowAssignOrg(false)}
          // secondaryButtonText={t('T_CANCEL')}
          // secondaryButtonWidth={'100px'}
          // primaryButtonText={t('T_BUTTON_UPDATE')}
          // primaryButtonWidth={'100px'}
          // primaryOnClick={() => {}}
          // primaryButtonDisabled={false}
        />
      )}
    </>
  );
};

export default AssignCategoryToOrg;
